import { render } from "./wfm-textarea.vue?vue&type=template&id=0ad87cee"
import script from "./wfm-textarea.vue?vue&type=script&lang=js"
export * from "./wfm-textarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__